import { Theme } from '@mui/material/styles';

export default function FormControl(theme: Theme) {
  return {
    MuiSwitch: {},
    MuiSelect: {},
    MuiAutocomplete: {},
    MuiRadio: {},
    MuiCheckbox: {},
    MuiInputBase: {},
    MuiInput: {},
    MuiFilledInput: {},
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          boxSizing: 'border-box',
          minWidth: 0,
          width: '100%',
          height: '48px',
          borderRadius: '8px',
          background: theme.palette.backgrounds.primary,
          '&:hover .MuiOutlinedInput-notchedOutline, &.Mui-focused .MuiOutlinedInput-notchedOutline':
            {
              border: `1px solid ${theme.palette.other.stroke}`,
            },
          '&.Mui-readOnly': {},
          ' &.Mui-disabled': {
            background: theme.palette.backgrounds.tertiary,
            '& .MuiOutlinedInput-notchedOutline': {
              border: `1px solid ${theme.palette.other.stroke}`,
            },
          },
          '&.Mui-error .MuiOutlinedInput-notchedOutline': {
            border: `1px solid ${theme.palette.red.light}`,
          },
          '&.MuiInputBase-multiline': {
            height: 'auto',
            padding: 0,
          },
          '&.MuiInputBase-adornedEnd': {
            paddingRight: '16px',
            '& .MuiInputBase-input': {
              paddingRight: 0,
            },
          },
        },
        input: {
          fontSize: '14px',
          fontWeight: 400,
          fontStyle: 'normal',
          lineHeight: '16px',
          letterSpacing: '0.25px',
          padding: '16px',
          color: theme.palette.text.primary,
          '&::placeholder': {
            fontSize: '14px',
            fontWeight: 400,
            fontStyle: 'normal',
            lineHeight: '16px',
            letterSpacing: '0.25px',
            color: '#B6B6B6',
            opacity: 1,
          },
          borderRight: 'none',
          '&.Mui-readOnly:not(.pir-datepicker), &.Mui-disabled': {
            WebkitTextFillColor: 'unset',
          },
        },
        inputMultiline: {
          fontSize: '14px',
          fontWeight: 400,
          fontStyle: 'normal',
          lineHeight: '16px',
          letterSpacing: '0.25px',
          padding: '16px',
          color: theme.palette.text.primary,
          '&::placeholder': {
            fontSize: '14px',
            fontWeight: 400,
            fontStyle: 'normal',
            lineHeight: '16px',
            letterSpacing: '0.25px',
            color: '#B6B6B6',
            opacity: 1,
          },
          borderRight: 'none',
          '&.Mui-readOnly, &.Mui-disabled': {
            WebkitTextFillColor: 'unset',
          },
        },
        notchedOutline: {
          border: `1px solid ${theme.palette.other.stroke}`,
        },
      },
    },
    MuiTextField: {},
  };
}
